import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';

const DEFAULT_BLOG_POSTS = [
  {
    id: 1,
    title: '¿CUÁL ES EL COSTE DE MANTENIMIENTO DE UN ASCENSOR?',
    publishDate: '2024-05-09',
    summary: 'En edificios, casas, locales comerciales, oficinas o centros comerciales, la revisión periódica de un ascensor debe ser una obligación...',
    imageUrl: 'https://images.unsplash.com/photo-1541888946425-d0fbb18615f3?w=300&q=80',
  },
  {
    id: 2,
    title: 'PRECIO DE INSTALAR UN ASCENSOR DE 4 PLANTAS. ¿Y UNO DE 3 PLANTAS?',
    publishDate: '2024-05-06',
    summary: 'Actualmente, el precio de instalar un ascensor de 3 o 4 plantas es una de las consultas más frecuentes que reciben las empresas...',
    imageUrl: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=300&q=80',
  },
  {
    id: 3,
    title: 'CARACTERÍSTICAS DE LOS MONTACARGAS PARA PERSONAS',
    publishDate: '2024-04-26',
    summary: 'Conoce las principales características y especificaciones técnicas de los montacargas diseñados para personas...',
    imageUrl: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=300&q=80',
  },
];

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    const months = [
      'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
      'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'
    ];
    return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
  } catch {
    return dateStr;
  }
};

const HomeBlogSection = ({ posts = [] }) => {
  const displayPosts = posts && posts.length > 0 ? posts : DEFAULT_BLOG_POSTS;

  return (
    <Box
      sx={{
        borderRadius: '18px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
        bgcolor: '#ffffff',
        p: { xs: 1.5, sm: 2 },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <Typography
          variant="h6"
          component="a"
          href="https://www.aszende.com/blog/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontWeight: 800,
            color: '#1f7bb6',
            fontSize: '1.05rem',
            letterSpacing: 0.5,
            textTransform: 'uppercase',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          BLOG
        </Typography>
        <Typography
          component="a"
          href="https://www.aszende.com/blog/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: '0.78rem',
            color: '#257eb9',
            fontWeight: 600,
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Ver todo →
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, flex: 1, overflow: 'auto' }}>
        {displayPosts.map((post) => {
          const targetUrl = post.linkUrl || post.link || 'https://www.aszende.com/blog/';

          return (
            <Box
              key={post.id}
              onClick={() => window.open(targetUrl, '_blank', 'noopener,noreferrer')}
              sx={{
                display: 'flex',
                gap: 1.5,
                alignItems: 'flex-start',
                transition: 'transform 0.2s',
                cursor: 'pointer',
                '&:hover': { transform: 'translateX(3px)' },
              }}
            >
              {/* Thumbnail */}
              <Box
                component="img"
                src={
                  post.imageUrl ||
                  'https://images.unsplash.com/photo-1541888946425-d0fbb18615f3?w=300&q=80'
                }
                alt={post.title}
                sx={{
                  width: 76,
                  height: 58,
                  borderRadius: '8px',
                  objectFit: 'cover',
                  flexShrink: 0,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                }}
              />

              {/* Info */}
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#64748b',
                    fontSize: '0.72rem',
                    fontWeight: 600,
                    letterSpacing: 0.3,
                    mb: 0.3,
                  }}
                >
                  {formatDate(post.publishDate)}
                </Typography>
                <Typography
                  sx={{
                    color: '#1f7bb6',
                    fontSize: '0.85rem',
                    fontWeight: 700,
                    lineHeight: 1.3,
                    mb: 0.5,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  {post.title}
                </Typography>
                <Typography
                  sx={{
                    color: '#475569',
                    fontSize: '0.78rem',
                    lineHeight: 1.45,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {post.summary || post.content}
                  <Typography
                    component="span"
                    sx={{
                      color: '#0f172a',
                      fontWeight: 700,
                      fontSize: '0.78rem',
                      ml: 0.5,
                      '&:hover': { textDecoration: 'underline' },
                    }}
                  >
                    Leer más
                  </Typography>
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>

      {/* Down Chevron */}
      <Box
        component="a"
        href="https://www.aszende.com/blog/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ display: 'flex', justifyContent: 'center', pt: 1.5, textDecoration: 'none' }}
      >
        <KeyboardArrowDown sx={{ color: '#257eb9', fontSize: '1.8rem', cursor: 'pointer' }} />
      </Box>

    </Box>
  );
};


HomeBlogSection.propTypes = {
  posts: PropTypes.array,
};

export default HomeBlogSection;


